export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/service-tax.d93b0fa8-33192c.png";